module.exports = __webpack_public_path__ + "static/img/y1.8153a696.jpg";